
import NewComponent from "../../../components/add_point_records/New.vue";

export default {
  components: {
    NewComponent
  }
};
